import { AppError } from '@vk-hr-tek/core/error';
import type { UnitNodeLabeled, UnitTypeOption } from '@vk-hr-tek/core/units';

import {
  EmployeeItem,
  CreateEventCompanyItem,
  EventBatchItem,
  AssignableRoles,
  CreateEventTypeOptionsCopyDocument,
  CreateEventTypeOptionsCopyAttribute,
  FormAttribute,
} from '@app/gen/events';
import { RootState } from '@app/store';
import { RequestStatus, CreateEventOption } from '@app/types';

import { EventTypeItemWithGroup } from '../types';

export interface CreationState {
  status: RequestStatus;
  error: AppError | null;
  creation: {
    status: RequestStatus;
    options: CreateEventOption[] | null;
    employees: {
      status: RequestStatus;
      list: EmployeeItem[];
    };
    items: CreateEventCompanyItem[] | null;
    error: AppError | null;
    canCreateBatch: boolean;
    canCreateForAnother: boolean;
    eventTypes: EventTypeItemWithGroup[] | null;
    employeeEventTypes: EventTypeItemWithGroup[] | null;
    selected: {
      company: { id: string; name: string };
      eventType: { id: string; name: string; documentInfoRequired: boolean };
      existingBatches: EventBatchItem[];
      unitTypeOptions?: UnitTypeOption[];
      rootUnit?: UnitNodeLabeled | null;
    } | null;
    availableEmployees: number;
    allEmployees: number;
  };
  createEventTypeOptions: {
    status: RequestStatus;
    options: Record<
      string,
      {
        assignableRoles?: AssignableRoles;
        copyDocuments?: CreateEventTypeOptionsCopyDocument[];
        copyAttributes?: CreateEventTypeOptionsCopyAttribute[];
        formAttributes?: FormAttribute[];
        documentRequired?: boolean;
        addListEmployees?: boolean;
      }
    >;
    error: AppError | null;
  };
  createEventData: {
    modalType: string;
    companyIds?: string[];
    eventTypeIds?: string[];
  } | null;
}

export const initialState: CreationState = {
  status: 'idle',
  error: null,

  creation: {
    employees: {
      status: 'idle',
      list: [],
    },
    status: 'idle',
    options: null,
    items: null,
    eventTypes: null,
    employeeEventTypes: null,
    error: null,
    canCreateBatch: false,
    canCreateForAnother: false,
    selected: null,
    allEmployees: 0,
    availableEmployees: 0,
  },
  createEventTypeOptions: {
    status: 'idle',
    options: {},
    error: null,
  },
  createEventData: null,
};

export interface CreationWithRootState extends RootState {
  creationEvent: CreationState;
}
